"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validGroceryCategory = exports.GROCERY_CATEGORY_NAME_MAX_LENGTH = exports.GROCERY_ITEM_KEYWORD_MAX_LENGTH = exports.GROCERY_ITEM_NAME_MAX_LENGTH = void 0;
const instance_1 = __importDefault(require("./instance"));
const errorMessageGenerator_1 = require("../utils/errorMessageGenerator");
exports.GROCERY_ITEM_NAME_MAX_LENGTH = 1000;
exports.GROCERY_ITEM_KEYWORD_MAX_LENGTH = 1000;
exports.GROCERY_CATEGORY_NAME_MAX_LENGTH = 1000;
exports.validGroceryCategory = instance_1.default.object().shape({
    name: instance_1.default
        .string()
        .required(errorMessageGenerator_1.requiredError)
        .max(exports.GROCERY_CATEGORY_NAME_MAX_LENGTH, errorMessageGenerator_1.maxCharactersError(exports.GROCERY_CATEGORY_NAME_MAX_LENGTH))
});
//# sourceMappingURL=grocery.js.map